import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '../../../../components';
import useStyles from '../styles';

type Props = {
  disabled: boolean;
  validPaymentData: boolean;
  useSavedCard: boolean;
};

const CheckoutFormSubmitButton = ({ validPaymentData, disabled, useSavedCard }: Props) => {
  const classes = useStyles();
  const { formState: { isValid } } = useFormContext();

  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      disabled={disabled || ((!isValid || !validPaymentData) && !useSavedCard)}
      classes={{
        root: classes.submitButtonRoot,
        label: classes.submitButtonLabel,
      }}
      data-intercom-target="Button: M"
    >
      Check out
    </Button>
  );
};

export default CheckoutFormSubmitButton;
